import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Alexa Kreizinger --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Pipeline metadata";
const frontMatter = {
  "title": "Pipeline metadata",
  "description": "Access pipeline metadata in Chronosphere Telemetry Pipeline."
};
export function useTOC(props) {
  return [{
    value: "Get pipeline IDs",
    id: "get-pipeline-ids",
    depth: 2
  }, {
    value: "Back up pipeline configuration files",
    id: "back-up-pipeline-configuration-files",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    blockquote: "blockquote",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    p: "p",
    pre: "pre",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Pipeline metadata"}</_components.h1>{"\n"}<_components.p>{"Use the information on this page to access pipeline metadata."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"After you "}<_components.a href="/pipeline-data/create-modify">{"create a pipeline"}</_components.a>{", Telemetry\nPipeline assigns that pipeline a unique numerical ID."}</_components.p>{"\n"}<_components.p>{"To retrieve a list of IDs for all pipelines within a\n"}<_components.a href="/pipelines/concepts#core-instance">{"Core Instance"}</_components.a>{",\nrun the following "}<_components.a href="/pipeline-cli">{"Pipeline CLI"}</_components.a>{" command:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"calyptia"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" get"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" pipelines"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" --core-instance"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" INSTANCE"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" --show-ids"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"Replace "}<_components.em><_components.code>{"INSTANCE"}</_components.code></_components.em>{" with the name of your Core Instance."}</_components.p>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.blockquote>{"\n"}<_components.p>{"Requires Pipeline CLI version 3.17.0 or later."}</_components.p>{"\n"}</_components.blockquote>{"\n"}<_components.p>{"You can run the following script to back up the "}<_components.a href="/pipeline-configure/config-files">{"configuration files"}</_components.a>{"\nfor each pipeline across all of your Core Instances:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"curl"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -sSfL"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" https://raw.githubusercontent.com/chronosphereio/calyptia-cli/refs/heads/main/dump-all-pipelines.sh"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{" |"}</_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{" bash"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"The resulting configuration files are stored in your current working directory,\nwith a subfolder for each Core Instance that contains the configuration files\nfor all of its associated pipelines."}</_components.p></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/pipeline-configure/metadata',
  {"filePath":"pages/pipeline-configure/metadata.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)